"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GaiaSDK = require("./all");
module.exports = GaiaSDK;
if (typeof document !== "undefined") {
    require("./lib/structure.scss");
}
